/**
 * Cookiekeuze met doelgroepknoppen: combineert de Avada-cookie-acceptatie met
 * de B2B/B2C-keuze in het eerste scherm (verzoek Ivo 01-09, voorbeeld
 * dpj-workspace). Zie snippets/iv-consent-audience.liquid voor de markup.
 *
 * - Toont alleen zolang het avada_cookie_consent-cookie ontbreekt (accepteren
 *   en weigeren zetten dat allebei) en nooit in de theme-editor.
 * - "Bedrijf"/"Particulier": doelgroep via window.IVAudience.set(), daarna de
 *   echte accepteer-knop van Avada (.Avada-CookiesBar_BtnAgree) aanklikken
 *   zodra die gerenderd is (de app injecteert traag, tot ~15 s; gemeten
 *   02-09: de klik zet het volledige consent-cookie en de balk ruimt zichzelf
 *   op). Tot die klik houdt html.iv-ca-pending de balk onzichtbaar.
 * - "Cookies beheren" (of Escape, of een klik naast de kaart): dit scherm weg,
 *   de gewone Avada-balk zichtbaar; zonder keuze verschijnt dit scherm op de
 *   volgende pagina opnieuw, precies zoals een consentbanner hoort.
 * - Rendert de balk nooit (adblocker of app uit), dan stopt het wachten na
 *   ~30 s: de doelgroepkeuze blijft staan, consent blijft aan Avada.
 */
(function () {
  'use strict';

  var root = document.getElementById('iv-consent-audience');
  if (!root) return;

  function heeftConsent() {
    return /(?:^|;\s*)avada_cookie_consent=/.test(document.cookie);
  }

  if (heeftConsent() || (window.Shopify && window.Shopify.designMode)) {
    root.remove();
    return;
  }

  var html = document.documentElement;
  html.classList.add('iv-ca-open');
  root.hidden = false;
  var eersteKnop = root.querySelector('button');
  if (eersteKnop) eersteKnop.focus();

  function sluit() {
    html.classList.remove('iv-ca-open');
    root.remove();
    document.removeEventListener('keydown', opToets);
  }

  function accepteerAvada() {
    var pogingen = 0;
    (function poging() {
      var balk = document.getElementById('Avada-CookiesBar') || document.getElementById('Avada-CookiesBarMobile');
      var knop = balk && balk.querySelector('.Avada-CookiesBar_BtnAgree');
      if (knop) {
        knop.click();
        html.classList.remove('iv-ca-pending');
        return;
      }
      pogingen += 1;
      if (pogingen > 120) {
        /* Balk komt niet (adblocker of app uit): consent blijft aan Avada. */
        html.classList.remove('iv-ca-pending');
        return;
      }
      setTimeout(poging, 250);
    })();
  }

  function kies(aud) {
    if (window.IVAudience) window.IVAudience.set(aud);
    html.classList.add('iv-ca-pending');
    sluit();
    accepteerAvada();
  }

  function beheer() {
    sluit();
  }

  function opToets(e) {
    if (e.key === 'Escape') beheer();
  }

  root.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-iv-ca]');
    if (!knop) {
      if (e.target === root) beheer();
      return;
    }
    var actie = knop.getAttribute('data-iv-ca');
    if (actie === 'b2b' || actie === 'b2c') kies(actie);
    else beheer();
  });

  document.addEventListener('keydown', opToets);
})();
